export default __webpack_public_path__ + "static/media/icons-persona-nueva.3dc6c78b.svg";